import { ThemeProvider } from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import AppLayout from "./AppLayout";
import { ToastContainer } from "react-toastify";
import { ToastMessage } from "./Utils/UIMessages";
import "./App.scss";
import "./fluent-edit-css.scss";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "./Constants/AppRoutes";
import { refreshToken } from "./Utils/Generic";
// import { useSelector } from "react-redux";
// import { GlobalState } from "./Redux/RootReducer";
import { AppConfig } from "./Config";

const appTheme = {
  status: {
    danger: "blue",
  },
  palette: {
 themePrimary: '#d40000',
    themeLighterAlt: '#fdf3f3',
    themeLighter: '#f8d0d0',
    themeLight: '#f2a9a9',
    themeTertiary: '#e55c5c',
    themeSecondary: '#d91a1a',
    themeDarkAlt: '#be0000',
    themeDark: '#a10000',
    themeDarker: '#770000',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#b6b2af',
    neutralSecondary: '#9f9a96',
    neutralPrimaryAlt: '#87837e',
    neutralPrimary: '#292624',
    neutralDark: '#585450',
    black: '#403d39',
    white: '#ffffff',
  },
};

(window as any).generateAlarms = function (sentinelIds: number[]) {
  let alarms = [
    "data?lidarSx=10",
    "data?idarDx=10",
    "data?rumore=100",
    "data?pesogr=10",
    "data?door=1",
  ];
  sentinelIds.forEach((sentinelId) => {
    alarms.forEach((item, i) => {
      fetch(
        AppConfig.api.sentinelsUrl + "/" + sentinelId + "/" + item
      );
    });
  });
};

(window as any).sendDoorKeepalive = function (
  sentinelId: number,
  batteryLevel: number
) {
  fetch(
    AppConfig.api.sensorsUrl + "/doorsensor/keepalive?batteryLevel=" +
      batteryLevel +
      "&id=" +
      sentinelId
  );
};

initializeIcons();
(window as any)["ToastMessage"] = ToastMessage;
const App = () => {
  const navigate = useNavigate();
  const expiredSession = async () => {
    let sessionHasBeenRestored: "yes" | "no" | "wait" = await refreshToken();

    if (sessionHasBeenRestored === "no") {
      (window as any)["SessionExpired"] = true;
      navigate(AppRoutes.APP_LOGIN_PAGE);
    } else if (sessionHasBeenRestored === "yes") {
      // Emetti evento per notificare che il token è stato rinnovato
      const event = new CustomEvent("token-refreshed");
      document.dispatchEvent(event);
      console.log("Token rinnovato con successo, evento emesso");
    }
  };
  (window as any)["expiredSession"] = expiredSession;
  return (
    <ThemeProvider theme={appTheme}>
      <ToastContainer />
      <AppLayout />
    </ThemeProvider>
  );
};

export default App;
